// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1Izl4","disabled":"FileBtn_disabled__32bT7","warn":"FileBtn_warn__2OFZI","fade":"FileBtn_fade__3wtr9"};